//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import wxLogin from './login.vue';
//  import wxLogin from './wxLogin.vue';
export default {
    components: {
        // wxLogin
    },
    data() {
        return {
            shippingCartBadge: '', // 购物车数量
            CSRBadge: '' // 未读消息数量
        };
    },
    computed: {
        carBadge: {
            get() {
                return this.$store.state.carBadge;
            },
            set(value) {
                this.$store.state.carBadge = value;
            }
        },
        csrBadge: {
            // 未读消息数
            get() {
                return this.$store.state.unreadMessageNum;
            },
            set(value) {
                this.$store.state.unreadMessageNum = value;
            }
        },
        token() {
            return this.$store.state.token;
        },
        userInfo() {
            return this.$store.state.userInfo;
        }
    },
    watch: {
        userInfo: {
            handler(userInfo) {
                if (userInfo && userInfo.shopperId) {
                    this.$store.state.APPPAGE.getOrderCartNum();
                } else {
                    this.carBadge = this.csrBadge = 0;
                }
            },
            deep: true
        }
    },
    methods: {
        routerPush(path) {
            if (this.$route.path != path) {
                this.$router.push(path);
            }
        },
        // 微信登录
        toWXLogin() {
            this.$store.state.pcLoginShow = true;
        }
    },
    mounted() {

    }
};



// WEBPACK FOOTER //
// ./src/pcComponents/home/header.vue